import React, {useCallback, useMemo, useState} from 'react';
import {Layout} from '@di-nxt/components';
import {Screen} from '../../components';
import {useTeamMembers, MembersLoader, TeamMember} from '../../services';
import {query} from '@di-nxt/query';
import {MembersHeader, Search, MemberList} from './components';
import {isMatch} from './functions';
import {useRemoveMembership} from './hooks';
import {useAddMemberTask} from '../modals/addmembership/task';

type Props = {
  teamId: number;
  onSelectMember?: (member: TeamMember) => void;
};

export const Members: React.FC<Props> = ({teamId, onSelectMember}) => {
  const allMembers = useTeamMembers(teamId);
  const [searchOn, setSearchOn] = useState('');

  const membersFiltered = useMemo(
    () =>
      query(allMembers)
        .where(m => isMatch(searchOn, m))
        .toArray(),
    [allMembers, searchOn],
  );

  // Callbacks
  const handleMemberSelected = useCallback(
    (member: TeamMember) => {
      // Navigate to team member
      onSelectMember && onSelectMember(member);
    },
    [onSelectMember],
  );

  // Dialogs
  const handleRemoveMembership = useRemoveMembership(teamId);
  const showAddMembersDialog = useAddMemberTask(teamId);

  return (
    <Screen>
      <MembersLoader teamId={teamId} />
      <Layout vertical flex>
        {/** Header */}
        <MembersHeader
          members={allMembers}
          onAddPeople={showAddMembersDialog}
        />
        {/** Search */}
        <Search value={searchOn} onChange={setSearchOn} />
        {/** Content */}
        <MemberList
          members={membersFiltered}
          onSelectMember={handleMemberSelected}
          onRemove={handleRemoveMembership}
        />
      </Layout>
    </Screen>
  );
};
